import * as React from 'react'
import { Typography } from '@lacedltd/laced-components'
import { useModal } from 'hooks'
import { PauseListingModal } from './PauseListingModal'
import { PauseListingsProps } from './PauseListing.types'
import { useTogglePause } from './useTogglePause'
import * as S from './PauseListing.styles'

const PauseListing = ({
  pauseState,
  userAction,
  userId,
  id
}: PauseListingsProps) => {
  const [isPaused, setIsPaused] = React.useState(pauseState)

  const { togglePause, isLoading, error } = useTogglePause(userId, id)
  const { Modal, toggleModal, modalProps } = useModal({
    align: 'center',
    justify: 'center',
    width: 400,
    drawer: true
  })

  const handlePauseToggle = async (
    pause: boolean,
    reason?: string,
    additionalNote?: string
  ) => {
    try {
      await togglePause({
        userAction,
        pause,
        reason,
        additionalNote
      })

      setIsPaused(pause)

      if (pause) {
        toggleModal()
      }
    } catch (error) {
      console.error(
        `Failed to ${pause ? 'pause' : 'resume'} selling activity:`,
        error
      )
    }
  }

  return (
    <>
      <S.PauseListingButton
        type="button"
        data-testid={userAction ? 'pause-user' : 'pause-listing'}
        disabled={isLoading}
        onClick={() => (isPaused ? handlePauseToggle(false) : toggleModal())}
      >
        {isPaused ? 'Unpause' : 'Pause'} {userAction && 'User'}
      </S.PauseListingButton>

      <Modal {...modalProps} toggleModal={() => toggleModal()}>
        <Typography.Heading as="h3">
          {userAction ? 'Pause User' : 'Pause Listing'}
        </Typography.Heading>
        <PauseListingModal
          handlePauseClick={handlePauseToggle}
          loading={isLoading}
          error={error}
        />
      </Modal>
    </>
  )
}

export default PauseListing
